import Home from "../Views/Home/Home";
import CreateAccount from "../Views/CreateAccount/CreateAccount";
import AboutUs from "../Views/AboutUs/About";
import ValidateInfo from "../Views/ValidateInfo/ValidateInfo";
import VerifyCodeSMS from "../Views/VerifyCodeSMS/VerifyCodeSMS";
import Memberships from "../Views/Memberships/Memberships";
import Coaches from "../Views/Coaches/Coaches";
import Services from "../Views/Services/Services";
import ValidateSuccessEmail from "../Views/ValidateSuccessEmail/ValidateSuccesEmail";
import ValidationExpired from "../Views/ValidationExpired/ValidationExpired";
import HistoryActivity from "../Views/Dashboard/pagesUser/HistoryActivity/HistoryActivity";
import ResetPassword from "../Views/ResetPassword/ResetPassword";
import Community from "../Views/Community/Communiy";
import CompleteRoutes from "../Views/Dashboard/pagesUser/CompleteRoutes/CompleteRoutes";
import MapboxMap from "../Views/Dashboard/pagesUser/Routes/NewRoute";
import SendEmailForNewPassword from "../Views/ResetPassword/SendEmailForNewPassword";
import MembreshipOfUser from "../components/Dashboard/Membership/MembreshipOfUser";
import ProfileUser from "../components/Dashboard/ProfileUser/ProfileUser";
import OffertsOfUser from "../Views/Dashboard/pagesUser/OffertsOfUser/OffertsOfuser";
import UserAccount from "../components/Dashboard/UserAccount/UserAccount";
import ListMembershipUser from "../components/Dashboard/UserAccount/ListMembershipUser";
import Patients from "../Views/DashboardServices/PagesServicesProviders/Patients/Patients";
import AddPatient from "../Views/DashboardServices/PagesServicesProviders/AddPatient/AddPatient";
import AsignedRoute from "../Views/DashboardServices/PagesServicesProviders/AsignedRoute/AsignedRoute";
import NutricionistScreen from "../Views/Dashboard/pagesUser/HealthScreens/NutricionistScreen";
import PhysiotherapyScreen from "../Views/Dashboard/pagesUser/HealthScreens/PhysiotherapyScreen";
import PsicologyScreen from "../Views/Dashboard/pagesUser/HealthScreens/PsicologyScreen";
import TrainingScreen from "../Views/Dashboard/pagesUser/HealthScreens/TrainingScreen";
import BadgeScreen from "../Views/Dashboard/pagesUser/BadgesUser/BadgesScreen";
import RunningsClubs from "../Views/Dashboard/pagesUser/RunningsClubs/RunningClubs";
import RunningsClubsProvider from "../Views/DashboardServices/PagesServicesProviders/RunningClubs/RunningsClubs";
import PublicRoutes from "../Views/Dashboard/pagesUser/PublicRoutes/PublicRoutes";
import ProfileRunningClubProvider from "../Views/DashboardServices/PagesServicesProviders/RunningClubs/ProfileRunningClub/ProfileRunningClub";
import ProfileRunningClubUser from "../Views/Dashboard/pagesUser/RunningsClubs/ProfileRunningClubUser";
import SigInSpecialist from "../Views/SigInSpecialist/SigninSpecialist";
import SuccessPayment from "../Views/StatusPaymentMembership/SuccessPayment";
import FiledPayment from "../Views/StatusPaymentMembership/FiledPayment";
import PrivacyPolicy from "../Views/Privacy-Policies/Privacity-Policies";

export const routes = [
  {
    name: "Home",
    path: "/",
    Component: Home,
  },
  {
    name: "Auth",
    path: "/auth",
    Component: CreateAccount,
  },
  {
    name: "AthSpecialist",
    path: "/auth/specialist",
    Component: SigInSpecialist,
  },

  {
    name: "ValidateInfo",
  },

  {
    name: "AboutUs",
    path: "/about-us",
    Component: AboutUs,
  },
  {
    name: "Memberships",
    path: "/memberships",
    Component: Memberships,
  },
  {
    name: "SuccessPayment",
    path: "/success-payment",
    Component: SuccessPayment,
  },
  {
    name: "FiledPayment",
    path: "/filed-payment",
    Component: FiledPayment,
  },
  {
    name: "Coaches",
    path: "/coaches",
    Component: Coaches,
  },
  {
    name: "Services",
    path: "/services",
    Component: Services,
  },
  {
    name: "Community",
    path: "/community",
    Component: Community,
  },
  {
    //Pantalla de verificación de email exitosa
    name: "ValidateSuccesWeb",
    path: "/validateSuccess/:name/:origin",
    Component: ValidateSuccessEmail,
  },
  {
    //Pantalla de expiración de token para verificar email
    name: "ValidatonExpired",
    path: "/validationExpired",
    Component: ValidationExpired,
  },
  {
    name: "ResetPassword",
    path: "/reset-password",
    Component: SendEmailForNewPassword,
  },

  {
    name: "NewPassword",
    path: "/new-password/:token",
    Component: ResetPassword,
  },
  {
    name: "PrivacyPolicy",
    path: "/privacy-policy",
    Component: PrivacyPolicy,
  },
];

export const protectedRoutes = [
  {
    name: "Verified",
    path: "/verifyInformation/:name",
    Component: ValidateInfo,
  },
  {
    name: "VerifiedCode",
    path: "/verifyCode",
    Component: VerifyCodeSMS,
  },
];
export const profileRoutes = [
  {
    name: "RutasComplete",
    path: "rutasComplete",
    Component: CompleteRoutes,
  },
  {
    name: "HistoryActivity",
    path: "history",
    Component: HistoryActivity,
  },
  {
    name: "Routes",
    path: "rutasComplete/new-route",
    Component: MapboxMap,
  },
  {
    name: "MembershipOfUser",
    path: "membership",
    Component: MembreshipOfUser,
  },
  {
    name: "UserProfile",
    path: "profile",
    Component: ProfileUser,
  },
  {
    name: "OffertsOfUser",
    path: "offerts",
    Component: OffertsOfUser,
  },
  {
    name: "userAccount",
    path: "account",
    Component: UserAccount,
  },
  {
    name: "ListMemberships",
    path: "list-memberships",
    Component: ListMembershipUser,
  },
  {
    name: "ListServices",
    path: "nutricionist-user",
    Component: NutricionistScreen,
  },
  {
    name: "ListServices",
    path: "physiotherapy-user",
    Component: PhysiotherapyScreen,
  },
  {
    name: "ListServices",
    path: "psicology-user",
    Component: PsicologyScreen,
  },
  {
    name: "ListServices",
    path: "training-user",
    Component: TrainingScreen,
  },
  {
    name: "ListServices",
    path: "list-badges",
    Component: BadgeScreen,
  },
  {
    name: "RunningsClubs",
    path: "runnings-clubs",
    Component: RunningsClubs,
  },
  {
    name: "ProfileRunningClub",
    path: "runnings-clubs/profile-club",
    Component: ProfileRunningClubUser,
  },
  {
    name: "Rutas publicas",
    path: "public-routes",
    Component: PublicRoutes,
  },
];
export const profileUserprovider = [
  {
    name: "Patients",
    path: "list-patients",
    Component: Patients,
  },
  {
    name: "AddPatient",
    path: "add-patient",
    Component: AddPatient,
  },

  {
    name: "asignedRoute",
    path: "asigned-route-provider",
    Component: AsignedRoute,
  },
  {
    name: "asignedRoute",
    path: "runing-clubs-provider",
    Component: RunningsClubsProvider,
  },
  {
    name: "ProfileRunningcClubProvider",
    path: "profile-running-club-provider",
    Component: ProfileRunningClubProvider,
  },
];
